import { render, staticRenderFns } from "./couponCost.vue?vue&type=template&id=5815835b&scoped=true&"
import script from "./couponCost.vue?vue&type=script&lang=js&"
export * from "./couponCost.vue?vue&type=script&lang=js&"
import style0 from "./couponCost.vue?vue&type=style&index=0&id=5815835b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5815835b",
  null
  
)

export default component.exports